import React, { useState, useEffect, useRef } from "react";
import TeacherPageContainer from "../Container/TeacherPageContainer";
import { connect } from "react-redux";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ReactTooltip from "react-tooltip";
import { ShareVideoModal } from "./ShareVideoModal";

const TeacherUserManual = (props) => {
  const videos = []
  const [filteredVideos, setFilteredVideos] = useState(videos)
  const [sharedVideo, setSharedVideo] = useState(undefined)

  const search = (e) => {
    const keyword = e.target.value?.toLowerCase()
    const searchVideos = videos.filter(v => (v.name + " " + v.keywords).toLowerCase().includes(keyword))
    setFilteredVideos(searchVideos)
  }

  return (
    <TeacherPageContainer user={props.user} header="User Manual">
      <div className="row ml-4 mr-5 my-4">
        <SearchBar
          onChange={search}
        />
      </div>

      <div className="row mx-2">
        {filteredVideos.map(v => <div className="col-md-6 mt-3 mb-4">
            <div>
              <h3 className="text-center">{v.name}</h3>
              <button
                className="btn btn-primary share-video-button ml-3"
                data-tip="Share Video"
                data-for="share-video"
                onClick={() => {
                  setSharedVideo(v);
                }}
              >
                <a
                  className="mdi mdi-share share-video-icon"
                />
                <ReactTooltip
                  place="top"
                  backgroundColor="rgb(47, 224, 222)"
                  effect="solid"
                  id="share-video"
                />
              </button>
            </div>
            <div className="help-video-container mt-3">
              <iframe
                src={"https://www.loom.com/embed/" + v.id}
                frameBorder="0"
                allowFullScreen
                className="help-video"
              />
            </div>
          </div>

        )}

        {sharedVideo && <ShareVideoModal video={sharedVideo} onClose={() => setSharedVideo(undefined)} />}

      </div>
    </TeacherPageContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state.user.user,
  };
}

export default connect(mapStateToProps)(TeacherUserManual);
